
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { ArrowRight } from 'lucide-react';
import Heading from '@/components/ui/heading';
import { Link } from 'react-router-dom';

const CallToAction = () => {
  return (
    <section className="py-28 relative overflow-hidden">
      {/* Enhanced background effects */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 via-gray-900 to-gray-900"></div>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-blue-900/20 via-transparent to-transparent"></div>
      
      {/* Background effects */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-blue-700/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
      </div>
      
      <div className="container relative z-10 mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block py-1 px-3 text-sm font-medium bg-blue-900/40 text-blue-300 rounded-full backdrop-blur-sm border border-blue-800/50 mb-3">Start Free</span>
          <Heading level={2} className="mb-6 !text-3xl md:!text-4xl lg:!text-5xl !font-extrabold">
            Get Your First Market Intelligence Report Free
          </Heading>
          
          <p className="text-lg text-gray-300 mb-10 max-w-2xl mx-auto">
            Experience the power of AI-driven market research with no commitment. Sign up today and receive a complimentary report on any company or market of your choice.
          </p>
          
          <div className="bg-gray-800/30 backdrop-blur-sm border border-gray-700/30 p-8 rounded-2xl shadow-2xl mb-8 max-w-xl mx-auto">
            <div className="flex flex-col gap-5">
              <Input 
                type="email" 
                placeholder="Enter your email" 
                className="bg-gray-800/50 border-gray-700/50 text-gray-100 shadow-lg py-6 text-base transform hover:translate-y-[-2px] transition-all duration-300 rounded-xl"
              />
              <Button 
                className="w-full py-6 text-base font-medium rounded-xl bg-blue-600 hover:bg-blue-500 shadow-lg shadow-blue-600/20 hover:shadow-blue-500/30 transform hover:translate-y-[-2px] transition-all duration-300"
                asChild
              >
                <Link to="/auth">
                  Get Started
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
            </div>
            
            <p className="text-gray-400 text-sm mt-4 flex items-center justify-center gap-2">
              <span className="text-green-500 text-xl">✓</span> Your free report will be delivered instantly.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
